/**
 * Skeleton — placeholders de carga para optimistic UI / rendering incremental.
 *
 * Ofrece una primera respuesta visual útil en un Tiempo_Percibido ≤ 100 ms
 * (R16.1) mostrando la silueta del contenido mientras llegan los datos, en
 * lugar de un spinner o una pantalla en blanco. Ligero y sin dependencias.
 */
import type { CSSProperties } from "react";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  /** Forma del bloque. */
  variant?: "text" | "rect" | "circle";
  style?: CSSProperties;
}

export function Skeleton({
  width = "100%",
  height,
  variant = "text",
  style,
}: SkeletonProps): JSX.Element {
  const radius = variant === "circle" ? "50%" : variant === "rect" ? 6 : 4;
  const h = height ?? (variant === "text" ? 12 : variant === "circle" ? 36 : 48);
  return (
    <span
      className="skeleton"
      aria-hidden="true"
      style={{ width, height: h, borderRadius: radius, ...style }}
    />
  );
}

/** Skeleton de tabla: filas y columnas de placeholders. */
export function SkeletonTable({
  rows = 6,
  columns = 4,
}: {
  rows?: number;
  columns?: number;
}): JSX.Element {
  return (
    <div className="table-wrapper" aria-busy="true" aria-label="Cargando datos">
      <table className="data-table">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, c) => (
              <th key={c}>
                <Skeleton width="60%" />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, r) => (
            <tr key={r}>
              {Array.from({ length: columns }).map((_, c) => (
                <td key={c}>
                  <Skeleton width={c === 0 ? "40%" : "70%"} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
